import React from "react";
import _ from "lodash";
import Input from "Components/input/Input";
import { quotas } from "../../config";
import t from "Utils/translation";
import cx from "classnames";
import s from "./domainLimitsInputs.scss";

export default class DomainLimitsInputs extends React.Component {
  componentDidMount() {
    this.firstInput.focus();
  }

  updateMaxEmailAccountsLimit = values => {
    let o = {};

    [
      "max_email_accounts_100gb",
      "max_email_accounts_50gb",
      "max_email_accounts_25gb",
      "max_email_accounts",
      "max_email_accounts_archive"
    ].forEach(k => {
      if (values[k] || values[k] === 0) {
        o[k] = values[k];
      } else {
        o[k] = this.props.values[k];
      }
    });

    if (o.max_email_accounts !== -1 && o.max_email_accounts < o.max_email_accounts_archive) {
      o.max_email_accounts_archive = o.max_email_accounts;
    }

    if (o.max_email_accounts !== -1 && o.max_email_accounts_archive === -1) {
      o.max_email_accounts_archive = 0;
    }

    if (o.max_email_accounts !== -1 && o.max_email_accounts < o.max_email_accounts_25gb) {
      o.max_email_accounts_25gb = o.max_email_accounts;
    }

    if (o.max_email_accounts !== -1 && o.max_email_accounts < o.max_email_accounts_50gb) {
      o.max_email_accounts_50gb = o.max_email_accounts;
    }

    if (o.max_email_accounts !== -1 && o.max_email_accounts < o.max_email_accounts_100gb) {
      o.max_email_accounts_100gb = o.max_email_accounts;
    }

    if (o.max_email_accounts !== -1 && o.max_email_accounts_25gb === -1) {
      o.max_email_accounts_25gb = 0;
    }

    if (o.max_email_accounts !== -1 && o.max_email_accounts_50gb === -1) {
      o.max_email_accounts_50gb = 0;
    }

    if (o.max_email_accounts !== -1 && o.max_email_accounts_100gb === -1) {
      o.max_email_accounts_100gb = 0;
    }

    this.props.onChange({
      ...values,
      ...o
    });
  };

  render() {
    const {
      className,
      values,
      errors,
      onChange,
      disabled,
      plan,
      isLoggedUserAdmin,
      disabledFields = []
    } = this.props;

    return (
      <div className={cx(className, s.domainLimitsInputs)}>
        <Input
          name="max_email_accounts"
          type="number"
          label={t("input.label.maxAccountsAvailable8")}
          min={-1}
          max={999}
          step={1}
          onChange={this.updateMaxEmailAccountsLimit}
          errors={errors.max_email_accounts}
          value={values.max_email_accounts}
          onInput={this.setValues}
          required
          ref={el => (this.firstInput = el)}
          disabled={disabled || disabledFields.includes("max_email_accounts_8gb")}
        />

        <Input
          name="max_email_accounts_25gb"
          type="number"
          label={t("input.label.maxAccountsAvailable25")}
          min={-1}
          max={values.max_email_accounts !== -1 ? values.max_email_accounts : 9999999}
          step={1}
          onChange={this.updateMaxEmailAccountsLimit}
          errors={errors.max_email_accounts_25gb}
          value={values.max_email_accounts_25gb}
          onInput={this.setValues}
          required
          disabled={disabled || disabledFields.includes("max_email_accounts_25gb")}
        />

        {plan !== "basic" && (
          <React.Fragment>
            <Input
              name="max_email_accounts_50gb"
              type="number"
              label={t("input.label.maxAccountsAvailable50")}
              min={-1}
              max={values.max_email_accounts !== -1 ? values.max_email_accounts : 9999999}
              step={1}
              onChange={this.updateMaxEmailAccountsLimit}
              errors={errors.max_email_accounts_50gb}
              value={values.max_email_accounts_50gb}
              onInput={this.setValues}
              required
              disabled={disabled || disabledFields.includes("max_email_accounts_50gb")}
            />

            <Input
              name="max_email_accounts_100gb"
              type="number"
              label={t("input.label.maxAccountsAvailable100")}
              min={-1}
              max={values.max_email_accounts !== -1 ? values.max_email_accounts : 9999999}
              step={1}
              onChange={this.updateMaxEmailAccountsLimit}
              errors={errors.max_email_accounts_100gb}
              value={values.max_email_accounts_100gb}
              onInput={this.setValues}
              required
              disabled={disabled || disabledFields.includes("max_email_accounts_100gb")}
            />
          </React.Fragment>
        )}

        <Input
          name="max_email_accounts_archive"
          type="number"
          label={t("input.label.maxArchiveAvailable")}
          min={-1}
          max={values.max_email_accounts !== -1 ? values.max_email_accounts : 9999999}
          step={1}
          onChange={this.updateMaxEmailAccountsLimit}
          errors={errors.max_email_accounts_archive}
          value={values.max_email_accounts_archive}
          disabled={disabled || disabledFields.includes("max_email_accounts_archive")}
          required
        />
      </div>
    );
  }
}
